import { useEffect, useState } from "react";
import "./Skill.css";

type skill = {
  name: string;
  level: number;
};

const useLevel = (data: skill) => {
  const [level, setLevel] = useState(0);
  useEffect(() => {
    const int = setInterval(() => {
      if (level == data.level) {
        clearInterval(int);
        return;
      }
      setLevel((level) => level + 1);
    }, 150);
    return () => clearInterval(int);
  }, [level]);
  useEffect(() => {
    setLevel(() => 0);
  }, [data.name]);
  return level;
};
export default function Skill(props: skill) {
  var level = useLevel(props);
  useEffect(() => {
    const bars = document.getElementsByClassName("bar");
    for (var i = 0; i < level; ++i) {
      bars[i].className = "bar";
    }
  }, [props.name]);
  useEffect(() => {
    const bars = document.getElementsByClassName("bar");
    for (var i = 0; i < level; ++i) {
      bars[i].className = "bar " + "active";
    }
  }, [level]);
  return (
    <div className="skill">
      <div className="skill-content">
        <p className="text-2xl font-semibold text-center lg:text-left mb-2 text-orange-500">
          {props.name}
        </p>
        <div className="levels mb-5 flex-row flex space-x-5 bg-slate-800 w-fit p-3 pl-5 mx-auto lg:mx-0 border-r-[5px] border-green-400 lg:border-none">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>
    </div>
  );
}
